<template>
  <div class="chat-layout">
    <div class="chapter-list">
      <h3>全部章节</h3>
      <ul>
        <li
          v-for="node in playedNodes"
          :key="node.id"
          :class="['chapter-item', { active: node.id === node_id }]"
        >
          <el-button type="text" @click="retryNode(node.id)">
            {{ node.title }}
          </el-button>
        </li>
      </ul>
    </div>
    <div class="chat-main">
      <div class="chat-container">
        <div class="chat-history" ref="chatHistory">
          <div
            v-for="(msg, index) in messages"
            :key="index"
            :class="['chat-message', msg.sender.role_type=='NPC' || msg.sender.role_type=='NARRATOR' ? 'left' : 'right']"
          >
            <img :src="msg.sender.avatar" alt="avatar" class="avatar"  v-if="msg.sender.role_type !== 'NARRATOR'" />
            <div class="bubble">
              <span class="sender" v-if="msg.sender.role_type !== 'NARRATOR'">{{ msg.sender.name }}</span>
              <span v-if="msg.sender.role_type !== 'NARRATOR'">: </span>
              <span class="content" v-html="msg.content.replace(/\n/g, '<br>')"></span>
            </div>
          </div>
        </div>

        <div class="chat-input">
          <el-input
            type="textarea"
            v-model="inChat"
            placeholder="请输入消息..."
            :disabled="loading"
            rows="2"
            @keydown.native="handleKeyDown"
          />
          <div v-if="loading" style="margin-top: 10px; color: #999;">
            正在请求 Chat API...
          </div>
          <el-button
            type="primary"
            v-if="!isFinished"
            @click="sendMessage"
            :disabled="loading"
          >
            发送
          </el-button>
          <el-button
            type="success"
            v-else
            @click="goToNextNode"
          >
            下一章
          </el-button>
        </div>
        <el-button type="primary" @click="deleteCurrentRecord" style="margin-top: 20px">删除当前存档</el-button>
        <el-button type="danger" @click="deleteCurrentNodeMessages" style="margin-left: 10px;">开始/重新开始当前章节</el-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { getChatHistory, sendChat, Sender } from '@/api/chat'
import {delUserRecord, getUserRecord} from "@/api/record";
import {GameNode, retryPlayedNode} from "@/api/node";
import {getRoles} from "@/api/role";
import {getUserPlayNodes} from "@/api/node";
import {deleteRecordNode} from "@/api/node";
import {Game} from "@/api/game";


interface Message {
  sender: Sender
  content: string
}

@Component
export default class Chat extends Vue {
  @Prop({ required: true }) readonly game!: Game
  inChat = ''
  messages: Message[] = []
  record_id = -1
  node_id = -1
  currentNode: GameNode|undefined = undefined
  loading = false

  playedNodes: GameNode[] = []
  selectedNodeId: number | null = null
  isFinished = false;

  user: Sender = {
    name: '你',
    avatar: 'https://i.pravatar.cc/40?img=1',
    role_id: 2,
    role_type: 'npc',
  }

  @Watch("game", {immediate: true})
  onGameChange(newGame: Game){
    if (newGame && newGame.id) {
      this.loadData()
    }
  }

  // mounted() {
  // }

  loadData() {
    this.loadUserRecord().then(()=>{
      this.getRoles().then(()=>{
        let node_id = undefined
        if (this.node_id != -1){
          node_id = this.node_id
        }
        if (node_id == undefined){
          this.messages = []
          return
        }
        this.loadHistory(node_id)
      })
    })
    this.getPlayedNodes()
  }

  async deleteCurrentRecord(){
    try{
      await delUserRecord(this.record_id)
      this.$message.info('已删除当前存档，刷新页面重建存档')
    }catch (e){
      this.$message.error('删除失败')
    }
  }
  async goToNextNode() {
    // 假设 playedNodes 按顺序排列
    const idx = this.playedNodes.findIndex(n => n.id === this.node_id)
    if (idx !== -1 && idx < this.playedNodes.length - 1) {
      const nextNode = this.playedNodes[idx + 1]
      if (nextNode.id != null){
        this.node_id = nextNode.id
        this.$nextTick(this.scrollToBottom)
        console.log(`next_id is : ${nextNode.id}`)
      }
    } else {
      this.$message.info("已经是最后一章")
    }
  }

  async deleteCurrentNodeMessages() {
    try {
      const confirmed = await this.$confirm('确定删除当前节点的所有聊天记录吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
      console.log(`开始/重新开始当前章节 ${this.record_id}, ${this.node_id}`)
      await deleteRecordNode(this.record_id, this.node_id, false)
      this.$message.success('当前节点聊天已开始/重新开始')
      await this.loadHistory(this.node_id)
    } catch (e) {
      this.$message.info('已取消或删除失败')
    }
  }

  async loadUserRecord() {
    this.loading = true;
    try {
      const record = await getUserRecord(this.game.id)
      this.record_id = record.record_id
      this.node_id = record.node_id
      console.log(`存档名称： ${record.name}`)
    } catch (e) {
      this.$message.error('获取record失败')
    }finally {
      this.loading = false
    }
  }

  async loadHistory(node_id: number | undefined) {
    try {
      const history = await getChatHistory(this.record_id, node_id)
      let historyMsg = history.res
      this.messages = historyMsg.map(msg => ({
        sender: msg.sender,
        content: msg.content
      }))
      this.$nextTick(this.scrollToBottom)
      for (let i of this.messages){
        console.log(`print message: ${i.content}`)
      }
    } catch (e) {
      this.$message.error('加载历史失败')
      console.log('加载历史失败', e)
    }
  }

  async getRoles(){
    try{
      const roles = await getRoles(this.game.id)
      for (let r of roles){
        if (r.role_type == "USER"){
          this.user.name = r.name
          this.user.avatar = r.avatar_url
          this.user.role_id = r.id || 0
          this.user.role_type = r.role_type
        }
      }
    } catch (e){
      this.$message.error('加载历史失败')
    }
  }
  async sendMessage() {
    const content = this.inChat.trim()
    if (!content) return

    this.messages.push({ sender: this.user, content })
    this.inChat = ''
    this.$nextTick(this.scrollToBottom)

    try {
      this.loading = true
      const body = {"message": content, node_id: this.node_id, record_id: this.record_id}
      const response = await sendChat(body)
      for (let i of response.ret){
        this.messages.push({ sender: i.sender, content: i.reply })
      }
      this.node_id = response.node_id
      this.isFinished = response.is_finished  // 新增行
      this.$nextTick(this.scrollToBottom)
    } catch (e) {
      this.$message.error('系统回复失败')
    }finally {
      this.loading = false
    }
  }

  scrollToBottom() {
    const historyDiv = this.$refs.chatHistory as HTMLElement
    if (historyDiv) {
      historyDiv.scrollTop = historyDiv.scrollHeight
    }
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      this.sendMessage()
    }
  }

  async getPlayedNodes() {
    try {
      let res = await getUserPlayNodes(this.game.id)
      this.playedNodes = res || []
    } catch (e) {
      this.$message.error('加载已玩章节失败')
    }
  }

  retryNode(nodeId: number|undefined) {
    if (nodeId == undefined){
      this.$message("未选择章节")
      return
    }
    this.$confirm(
      `确定要跳转到章节 "${this.playedNodes.find(n => n.id === nodeId)?.title}" 吗？`,
      '提示',
      {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }
    ).then(() => {
      this.node_id = nodeId
      this.loadHistory(nodeId)
      console.log(`章节 id: ${nodeId}`)
    }).catch(() => {
      console.log('用户取消了重玩章节')
    })
  }

  async callRetryNode(nodeId: number) {
    try {
      await retryPlayedNode(nodeId)
      this.$message.success('已切换章节，请开始重玩')
      await this.loadUserRecord()
      await this.loadHistory(this.node_id)
    } catch (e) {
      this.$message.error('切换章节失败')
    }
  }
}
</script>

<style scoped>
.chat-layout {
  display: flex;
  max-width: 1000px;
  margin: auto;
}
.chapter-list {
  width: 200px;
  padding-right: 10px;
  border-right: 1px solid #ccc;
}
.chat-main {
  flex: 1;
  padding-left: 10px;
}
.chat-container {
  padding: 20px;
  max-width: 600px;
  margin: auto;
}
.chat-history {
  min-height: 300px;
  max-height: 500px;
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #f9f9f9;
  overflow-y: auto;
}
.chat-message {
  display: flex;
  margin-bottom: 10px;
  align-items: flex-start;
}
.chat-message.left {
  flex-direction: row;
}
.chat-message.right {
  flex-direction: row-reverse;
}
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin: 0 10px;
}
.bubble {
  max-width: 70%;
  padding: 10px;
  border-radius: 10px;
  background-color: #e6f7ff;
  word-break: break-word;
  text-align: left;
}
.chat-message.right .bubble {
  background-color: #d6f5d6;
  text-align: left;
}
.sender {
  font-weight: bold;
  display: block;
}
.chat-input {
  display: flex;
  gap: 10px;
  align-items: center;
}
/* 章节列表样式增强 */
.chapter-item {
  margin-bottom: 8px;
}

.chapter-item.active .el-button {
  background: linear-gradient(to right, #409EFF 90%, transparent 10%);
  color: white;
  border-radius: 4px 0 0 4px;
}

.chapter-item .el-button {
  width: 100%;
  text-align: left;
}
</style>